import React from 'react';
import { DocumentTextIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { getPhoneFormatExamples } from './newRunValidation';
import { IS_AUSTRALIA, PHONE_EXAMPLE_PRETTY } from '../../config/region';
import './NewRunTemplatePopup.css';

interface NewRunTemplatePopupProps {
  onDownload: () => void;
  onClose: () => void;
}

const NewRunTemplatePopup: React.FC<NewRunTemplatePopupProps> = ({
  onDownload,
  onClose,
}) => {
  const examples = getPhoneFormatExamples();
  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm overflow-y-auto custom-scrollbar h-full w-full z-50 flex items-center justify-center p-2 sm:p-4">
      <div className="relative bg-gray-900 border border-white/10 rounded-xl shadow-xl max-w-md w-full mx-2 sm:mx-4">
        <div className="p-4 sm:p-6">
          <div className="flex items-center mb-3 sm:mb-4">
            <DocumentTextIcon className="h-6 w-6 sm:h-8 sm:w-8 text-cyan-400 mr-2 sm:mr-3" />
            <h3 className="text-base sm:text-lg font-medium text-white">
              CSV Template Available
            </h3>
          </div>
          <p className="text-xs sm:text-sm text-gray-400 mb-4 sm:mb-6">
            Would you like to download a CSV template to see the exact format
            required? The template includes sample data showing the correct
            column names and phone number formats.
          </p>
          <div className="bg-white/5 border border-white/10 rounded-md p-2 sm:p-3 mb-4 sm:mb-6">
            <h4 className="text-xs font-medium text-gray-300 mb-1 sm:mb-2">
              Required columns:
            </h4>
            <ul className="text-xs text-gray-400 space-y-1">
              <li>
                • <strong className="text-gray-200">name</strong> - Contact's full name (required)
              </li>
              <li>
                • <strong className="text-gray-200">phone</strong> - Phone with country code: {PHONE_EXAMPLE_PRETTY}, etc. (required
                {IS_AUSTRALIA ? '; 04/07 without +61 not supported' : ''})
              </li>
              <li>
                • <strong className="text-gray-200">email</strong> - Email address (optional)
              </li>
            </ul>
          </div>
          <div className="bg-cyan-500/10 border border-cyan-500/30 rounded-md p-2 sm:p-3 mb-4 sm:mb-6">
            <h4 className="text-xs font-medium text-cyan-300 mb-1 sm:mb-2">
              Supported phone formats (with country code):
            </h4>
            <div className="text-xs text-cyan-200 space-y-1">
              {examples.map((example, index) => (
                <div key={index}>• {example}</div>
              ))}
            </div>
          </div>
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
            <button
              type="button"
              onClick={onDownload}
              className="flex-1 flex items-center justify-center px-3 sm:px-4 py-2 bg-cyan-500 hover:bg-cyan-600 text-white text-xs sm:text-sm font-medium rounded-md transition-colors"
            >
              <ArrowDownTrayIcon className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
              Download Template
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-3 sm:px-4 py-2 bg-white/10 hover:bg-white/15 border border-white/10 text-gray-300 hover:text-white text-xs sm:text-sm font-medium rounded-md transition-colors"
            >
              No Thanks
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewRunTemplatePopup;
